<div class="propero-home">
  <!-- Hero -->
  <section id="home" class="ph-hero">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__grid">
      <div class="ph-hero__content">
        <div class="ph-hero__badge">
          <span class="ph-hero__badge-dot" aria-hidden="true"></span>
          {{ 'PERSONALIZED_SOLUTION.FEATURES_TITLE' | translate }}
        </div>

        <h1 class="ph-hero__title">{{ 'PERSONALIZED_SOLUTION.TITLE' | translate }}</h1>
        <p class="ph-hero__subtitle">{{ 'PERSONALIZED_SOLUTION.TEXT' | translate }}</p>

        <div class="ph-hero__actions">
          <div class="ph-hero__cta-primary-wrap">
            <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
              Propero Assistant
            </a>
            <p class="ph-hero__cta-note">{{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}</p>
          </div>
          <a routerLink="/pricing" fragment="contact" class="ph-btn ph-btn--outline ph-btn--lg">
            {{ 'PRICING.REQUEST_OFFER_BUTTON' | translate }}
          </a>
        </div>
      </div>

      <div class="ph-hero__visual">
        <div class="ph-hero__visual-shadow" aria-hidden="true"></div>
        <div class="ph-hero__image-stack">
          <img
            src="assets/images/slider/2.png"
            alt="Propero — soluție personalizată"
            class="ph-hero__image ph-hero__image--active" />
        </div>
      </div>
    </div>
  </section>

  <!-- Deployment options -->
  <section id="features" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'PERSONALIZED_SOLUTION.FEATURES_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'PERSONALIZED_SOLUTION.FEATURES_TEXT' | translate }}</p>
      </div>

      <div class="ph-deploy__grid">
        <article *ngFor="let option of deploymentOptions" class="ph-deploy-card ph-card ph-card--hover">
          <div class="ph-deploy-card__icon">
            <img [src]="option.image" [alt]="option.titleKey | translate" />
          </div>
          <h3 class="ph-deploy-card__title">{{ option.titleKey | translate }}</h3>
          <p class="ph-deploy-card__text">{{ option.textKey | translate }}</p>
        </article>
      </div>

      <div class="ph-deploy__cta">
        <a routerLink="/solution-personalised" fragment="contact" class="ph-btn ph-btn--brand ph-btn--lg">
          {{ 'PERSONALIZED_SOLUTION.WANT_DETAILS' | translate }}
        </a>
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'PERSONALIZED_SOLUTION.CONTACT_TEXT' | translate }}</p>

        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="sp-contact-name">{{ 'PERSONALIZED_SOLUTION.NAME' | translate }}</label>
          <input
            id="sp-contact-name"
            type="text"
            name="name"
            [(ngModel)]="contactItem.subject"
            required
            [placeholder]="'PERSONALIZED_SOLUTION.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="sp-contact-email">{{ 'PERSONALIZED_SOLUTION.EMAIL' | translate }}</label>
          <input
            id="sp-contact-email"
            type="email"
            name="email"
            [(ngModel)]="contactItem.email"
            required
            email
            [placeholder]="'PERSONALIZED_SOLUTION.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="sp-contact-message">{{ 'PERSONALIZED_SOLUTION.MESSAGE' | translate }}</label>
          <textarea
            id="sp-contact-message"
            name="message"
            rows="4"
            [(ngModel)]="contactItem.content"
            required
            [placeholder]="'PERSONALIZED_SOLUTION.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">{{ 'CONTACT.FORM.SUCCESS' | translate }}</p>
      </form>
    </div>
  </section>
</div>
